<template>
  <div class="content">
    <div class="header">
      <img :src="projectConfig.logo" alt />
    </div>
    <div class="main">
      <el-card class="box-card">
        <p class="card-title">找回密码</p>
        <el-form
          ref="forgetform"
          :rules="forgetFormRule"
          :model="forgetForm"
          :hide-required-asterisk="true"
        >
          <el-form-item prop="userName">
            <el-input v-model="forgetForm.userName" placeholder="请输入账号">
              <el-select v-model="areaCode" slot="prepend" placeholder="请选择">
                <el-option-group
                  v-for="group in areaCodeList"
                  :key="group.code"
                  :label="group.zh"
                >
                  <el-option
                    v-for="item in group.options"
                    :key="item.en"
                    :label="`${item.zh} +${item.code}`"
                    :value="item.code"
                  >
                    <span style="float: left;">{{ item.zh }}</span>
                    <span style="float: right; color: #8492a6; font-size: 13px;"
                      >+{{ item.code }}</span
                    >
                  </el-option>
                </el-option-group>
              </el-select>
            </el-input>
          </el-form-item>
          <el-form-item prop="imageCaptchaCode">
            <el-input
              v-model="forgetForm.imageCaptchaCode"
              class="vcode-input"
              placeholder="请输入图形验证码"
            >
              <template slot="append">
                <img @click="findImageCaptcha" :src="imageCaptchaUrl" alt />
              </template>
            </el-input>
          </el-form-item>
          <el-form-item prop="captcha">
            <el-input
              v-model="forgetForm.captcha"
              class="vcode-input"
              placeholder="请输入短信验证码"
            >
              <template slot="append">
                <el-link
                  :underline="false"
                  type="primary"
                  @click="timer ? '' : findPassCaptch()"
                  >{{ timer ? `${timeCount}s后重发` : '获取验证码' }}</el-link
                >
              </template>
            </el-input>
          </el-form-item>
          <el-form-item prop="passWord">
            <el-input
              :type="isShowPassword ? 'text' : 'password'"
              v-model="forgetForm.passWord"
              placeholder="请设置新密码"
            >
              <i
                slot="append"
                class="iconfont"
                :class="isShowPassword ? 'icon002yincang' : 'iconyincang'"
                @click="isShowPassword = !isShowPassword"
              ></i>
            </el-input>
          </el-form-item>
        </el-form>
        <el-button class="login-btn" type="primary" @click="findPassWord"
          >登录</el-button
        >
        <div class="password-action clearfix">
          <el-link :underline="false" type="primary" @click="linkTo('/login')"
            >已有账号，立即登录</el-link
          >
        </div>
      </el-card>
    </div>
    <div class="footer">
      <p>
        {{ projectConfig.bottomTips1 }}
        <br />{{ projectConfig.bottomTips2 }}
      </p>
    </div>
  </div>
</template>

<script>
import areaCodeList from '@/assets/js/code.json'
import { findImageCaptcha, findPassCaptch, findPassWord } from '@/api'
import { mapState } from 'vuex'
export default {
  data() {
    return {
      forgetForm: {
        userName: '',
        passWord: '',
        imageCaptchaCode: '',
        imageCaptchaToken: '',
        captcha: ''
      },
      forgetFormRule: {
        userName: [
          {
            required: true,
            message: '请输入账号',
            trigger: 'blur'
          }
        ],
        passWord: [
          {
            required: true,
            message: '请输入密码',
            trigger: 'blur'
          }
        ],
        imageCaptchaCode: [
          {
            required: true,
            message: '请输入图形验证码',
            trigger: 'blur'
          }
        ],
        captcha: [
          {
            required: true,
            message: '请输入短信验证码',
            trigger: 'blur'
          }
        ]
      },
      areaCodeList: areaCodeList,
      areaCode: 86,
      isShowPassword: false,
      imageCaptchaUrl: '',
      timer: null,
      timeCount: 60
    }
  },
  computed: {
    ...mapState({
      projectConfig: state => state.projectConfig
    })
  },
  mounted() {
    this.findImageCaptcha()
  },
  methods: {
    findImageCaptcha() {
      findImageCaptcha().then(res => {
        if (res.code == 1) {
          this.imageCaptchaUrl = res.data.imageCaptchaUrl
          this.forgetForm.imageCaptchaToken = res.data.imageCaptchaToken
        }
      })
    },
    findPassCaptch() {
      if (!/^1[3456789]\d{9}$/.test(this.forgetForm.userName)) {
        this.$message.warning('请输入正确的手机号')
        return
      }
      if (!this.forgetForm.imageCaptchaCode) {
        this.$message.warning('请输入图形验证码')
        return
      }
      this.timeCount = 60
      findPassCaptch({
        userName: this.forgetForm.userName,
        imageCaptchaToken: this.forgetForm.imageCaptchaToken,
        imageCaptchaCode: this.forgetForm.imageCaptchaCode
      }).then(res => {
        if (res.code == 1) {
          this.timer = setInterval(() => {
            this.timeCount--
            if (this.timeCount == 0) {
              clearInterval(this.timer)
              this.timer = null
            }
          }, 1000)
        } else {
          this.$notify({
            title: '提示',
            message: res.msg,
            type: 'error',
            duration: 2000
          })
          this.findImageCaptcha()
        }
      })
    },
    findPassWord() {
      this.$refs.forgetform.validate(valid => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this.forgetForm))
          findPassWord(params).then(res => {
            if (res.code == 1) {
              this.$notify({
                title: '提示',
                message: '修改成功',
                type: 'success',
                duration: 2000
              })
              setTimeout(() => {
                this.$router.push({
                  path: '/login'
                })
              }, 1000)
            } else {
              this.$notify({
                title: '提示',
                message: res.msg,
                type: 'error',
                duration: 2000
              })
            }
          })
        } else {
          this.$notify({
            title: '提示',
            message: '请完善提交内容',
            type: 'error',
            duration: 2000
          })
          return false
        }
      })
    },
    linkTo(path) {
      this.$router.push({
        path: path
      })
    }
  }
}
</script>

<style lang="less" scoped>
.content {
  position: relative;
  width: 920px;
  height: 100%;
  margin: 0 auto;
  .header {
    padding: 31px 0 23px 0;
    border-bottom: 1px solid #eeeeee;
  }
  .main {
    padding-top: 60px;
    .box-card {
      margin: 0 auto;
      width: 420px;
      .card-title {
        font-size: 18px;
        line-height: 18px;
        margin-bottom: 40px;
        color: #333333;
        font-weight: bold;
      }
      .login-btn {
        width: 100%;
        margin-top: 10px;
        margin-bottom: 20px;
      }
    }
  }
  .footer {
    width: 100%;
    text-align: center;
    position: absolute;
    bottom: 43px;
    text-align: center;
    color: #bbbbbb;
    font-size: 12px;
    line-height: 22px;
  }
}
</style>

<style lang="less">
.box-card {
  .el-card__body {
    padding: 30px;
  }
  .is-error {
    .el-input-group__prepend,
    .el-input-group__append {
      border-color: red;
    }
  }
  .el-input {
    &.vcode-input input {
      height: 46px;
    }
    & > input {
      border-left: 0;
      border-right: 0;
      border-top: 0;
      border-radius: 0;
      padding: 0;
      &:focus {
        border-color: #dcdfe6;
      }
      &:hover {
        border-color: #dcdfe6;
      }
    }
    .el-input-group__prepend {
      min-width: 70px;
      width: auto;
      background: #fff;
      border-top: 0;
      border-left: 0;
      border-radius: 0;
    }
    .el-input-group__append {
      background: #fff;
      border-top: 0;
      border-left: 0;
      border-right: 0;
      border-radius: 0;
    }
  }
}
</style>
